function setCookie (name, value, expiredays) {
  const date = new Date();
  date.setTime(date.getTime() + expiredays * 24 * 3600 * 1000);
  const escapeValue = encodeURIComponent(value);
  const expireTime = date.toGMTString();
  document.cookie = `${name}=${escapeValue};expires=${expireTime}`;
}

function getCookie (name) {
  let name_start, token_start, token_end;
  if (document.cookie.length > 0) {
    name_start = document.cookie.indexOf(name + '=');
    if (name_start !== -1) {
      token_start = name_start + name.length + 1
      token_end = document.cookie.indexOf(';', token_start)
      if (token_end === -1) token_end = document.cookie.length
      return decodeURIComponent(document.cookie.substring(token_start, token_end))
    }
    return '';
  }
}

function clearCookie (name) {
  setCookie(name, '', -1);
}

export { setCookie, getCookie, clearCookie };



// WEBPACK FOOTER //
// ./src/utils/cookie.js